module.exports = __webpack_public_path__ + "static/media/banner3.f81dee5f.jpg";